module.exports = __webpack_public_path__ + "static/media/twitter-brands.6620c8ae.svg";